import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormBuilder, NgForm, Validators, FormGroup } from "@angular/forms";
import { BusinessRulesService } from "../../core/business-rules/business-rules.service";
import * as _ from 'lodash';
import * as moment from 'moment';
import { MessageService } from "primeng/components/common/messageservice";

@Component({
  //selector: 'pagos',
  templateUrl: 'businessRules.component.html',
  styleUrls: ['businessRules.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BusinessRulesComponent implements OnInit {

  amountsForm: FormGroup;

  melateGameInfo: any;
  mretroGameInfo: any;
  chispazoGameInfo: any;
  trisGameInfo: any;

  trisDrawDefinitions: any[];
  chispazoDrawDefinitions: any[];

  constructor(private formBuilder: FormBuilder,
              private businessService: BusinessRulesService,
              private messageService: MessageService) {
  }

  ngOnInit() {
    this.initGlobalForm(null);
    this.getBusinessRules();
  }

  private initGlobalForm(model: any) {
    this.amountsForm = this.formBuilder.group({
      globalAmount: [model ? model.globalAmount : '', Validators.required],
      ganalottodoAccount: this.formBuilder.group({
        minAmount: [model ? model.ganalottodoAccount.minAmount : '', Validators.required],
        maxAmount: [model ? model.ganalottodoAccount.maxAmount : '', Validators.required],
        paymentName: [model ? model.ganalottodoAccount.paymentName : '']
      }),
      ganalottodoCard: this.formBuilder.group({
        minAmount: [model ? model.ganalottodoCard.minAmount : '', Validators.required],
        maxAmount: [model ? model.ganalottodoCard.maxAmount : '', Validators.required],
        paymentName: [model ? model.ganalottodoCard.paymentName : '']
      })
    });
  }

  private getBusinessRules() {
    this.businessService.getBusinessRules("1")
      .subscribe(result => {
        let glottoAccount = _.find(result.paymentMethods, item => item.paymentName == 'ganalottodo_account');
        let card = _.find(result.paymentMethods, item => item.paymentName == 'card');
        let model: any = {
          globalAmount: result.globalAmount,
          ganalottodoAccount: {
            minAmount: glottoAccount.minAmount, maxAmount: glottoAccount.maxAmount, paymentName: glottoAccount.paymentName
          },
          ganalottodoCard: {
            minAmount: card.minAmount, maxAmount: card.maxAmount, paymentName: card.paymentName
          }
        }
        this.initGlobalForm(model);

      },
      error => {
        console.error(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
      })
  }

  onSubmitGlobalAmount() {
    if (this.amountsForm.valid) {
      console.log('montos globales');
      this.businessService.patchBusinessRules("1", this.amountsForm.value)
        .subscribe(
        response => {
          this.messageService.add({
            severity: 'success',
            summary: '',
            detail: 'La actualizacion fue satisfactoria.'
          });
          //          this.mretroGameInfo = response;
        },
        error => {
          console.error(error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error
          });
        })
    }

  }

  handleChange(event) {

    if (event.index == 3) {
      this.getMelateGameInfo();
    } else if (event.index == 4) {
      this.getMretroGameInfo();
    } else if (event.index == 5) {
      this.getChispazoGameInfo();
      this.getChispazoDrawDef();
    } else if (event.index == 6) {
      this.getGameInfoTris();
      this.getTrisDrawDef();
    }

  }

  private getMelateGameInfo() {
    this.businessService.getGameInfo("melate")
      .subscribe(
      response => {
        this.melateGameInfo = response;
      },
      error => {
        console.error(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
      });
  }

  private getMretroGameInfo() {
    this.businessService.getGameInfo("melateretro")
      .subscribe(
      response => {
        this.mretroGameInfo = response;
      },
      error => {
        console.error(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
      });
  }

  private getChispazoGameInfo() {
    this.businessService.getGameInfo("chispazo")
      .subscribe(
      response => {
        this.chispazoGameInfo = response;
      },
      error => {
        console.error(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
      });
  }

  private getChispazoDrawDef() {
    this.businessService.getDrawDefForInfo('chispazo')
      .subscribe(
      time => {
        this.chispazoDrawDefinitions =
          time
            .sort((a, b) => {
              if (a.chispazoDrawTimeId < b.chispazoDrawTimeId) return -1;
              if (a.chispazoDrawTimeId > b.chispazoDrawTimeId) return 1;

              return 0;
            })
            .map(item => ({
              gameIdentifier: item.chispazoDrawModuleId,
              time: item.chispazoDrawTimeId,
              description: item.chispazoDrawDefDesc,
              name: 'Chispazo'
            }));
      },
      error => {
        console.error(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
      });
  }

  private getGameInfoTris() {
    this.businessService.getGameInfo('tris')
      .subscribe(
      response => {
        this.trisGameInfo = response;
      },
      error => {
        console.error(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
      });
  }

  private getTrisDrawDef() {
    this.businessService.getDrawDefForInfo('tris')
      .subscribe(
      time => {
        this.trisDrawDefinitions =
          time
            .sort((a, b) => {
              if (a.trisDrawTimeId < b.trisDrawTimeId) return -1;
              if (a.trisDrawTimeId > b.trisDrawTimeId) return 1;

              return 0;
            })
            .map(item => ({
              gameIdentifier: item.trisDrawModuleId,
              time: item.trisDrawTimeId,
              description: item.trisDrawDefDesc,
              name: 'Tris'
            }));
      },
      error => {
        console.error(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
      });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/businessRules/businessRules.component.ts